module.exports = __webpack_public_path__ + "img/3.29d8289c.jpeg";